export const PAYMENT_METHOD_GOV_PO = 'Government Purchase Order';

export const wireInformation = `Account Name: WillyGoat
Account Number: 1234567890
Routing Number: 1234567890
SWIFT Code: 1234567890`;

export const wireInformationLink = 'https://cdn.shopify.com/s/files/1/0100/6072/6369/files/WillyGoat_ACH_Wire_Details.pdf?v=1772579585';

export const mailingAddress = `WillyGoat, LLC
PO Box 59278
Birmingham, AL 35259
`;


export const updateReasonOptionsValues = [
  {value: 'Add or Remove Items', label: 'Add or Remove Items', shortLabel: 'Add or remove items'},
  {value: 'Change Colors', label: 'Change Colors', shortLabel: 'Change colors'},
  {value: 'Add or Remove Installation', label: 'Add or Remove Installation', shortLabel: 'Add/Remove installation'},
  {value: 'Change Shipping/Contact Information', label: 'Change Shipping/Contact Information', shortLabel: 'Change shipping/contact info'},
  {value: 'Remove Taxes', label: 'Remove Taxes', shortLabel: 'Remove taxes'},
  {value: 'Something Else', label: 'Something Else', shortLabel: 'Something else'},
];

export const paymentOptions = [
  'Check',
  'Wire/ACH',
  PAYMENT_METHOD_GOV_PO,
  'Credit Card (voids discount)',
];

export const paymentOptionsValues = [
  { value: 'Please Select', defaultValue: true, disabled: true },
  { value: 'Check', disabled: false },
  { value: 'Wire/ACH', disabled: false },
  { value: PAYMENT_METHOD_GOV_PO, disabled: false },
  { value: 'Credit Card (voids discount)', disabled: true },
];


// Decline reasons + conditional follow-ups (additive; not currently wired into modalConfig.decline)
export const declineReasonOptionsValues = [
  {
    value: 'price_too_high',
    label: 'Price was outside of my price range',
    shortLabel: 'Price outside my range',
  },
  {
    value: 'cheaper_elsewhere',
    label: 'Found a better price',
    shortLabel: 'Better price',
  },
  {
    value: 'better_product',
    label: 'Found a better product for my needs',
    shortLabel: 'Better product',
  },
  {
    value: 'better_lead_time',
    label: 'Found a better lead time',
    shortLabel: 'Better lead time',
  },
  {
    value: 'project_cancelled_delayed',
    label: 'Project cancelled or delayed',
    shortLabel: 'Project cancelled or delayed',
  },
  {
    value: 'something_else_missed_mark',
    label: 'Something else missed the mark',
    shortLabel: 'Something else missed the mark',
  },
];



export const modalFieldDefinitions = {
  approve: [
    {
      name: 'paymentApproval',
      type: 'checkbox',
      label: 'I understand that approving this quote will cause WillyGoat to invoice me or my organization.',
      shortLabel: 'Approved invoice',
      size: 'large',
      // options: ["yes"],
      options: [
        { value: 'yes', label: 'Yes' },
      ],
      required: true,
      checked: false,
      fontWeight: 'bold',
    },
    {
      name: 'approvedShippingAddress',
      type: 'checkbox',
      label: 'I have reviewed and approve of the shipping and product information of my Quote',
      shortLabel: 'Approved shipping address',
      options: [
        { value: 'yes', label: 'Yes' },
      ],
      required: true,
      checked: false,
      fontWeight: 'bold',
    },
    // {
    //   name: 'approveProductInformation',
    //   type: 'checkbox',
    //   label: 'I’ve reviewed the shipping & product information',
    //   options: [
    //     { value: 'yes', label: 'Yes' },
    //   ],
    //   required: true,
    //   checked: false,
    //   // fontWeight: 'bold',
    // },
    {
      name: 'paymentMethod',
      type: 'select',
      label: 'Payment Method',
      options: paymentOptionsValues,
      required: true
    },
    // {
    //   name: 'wireInformation',
    //   type: 'readOnly',
    //   label: 'Wire Information',
    //   value: wireInformation,
    // },
    {
      name: 'wireInformation',
      type: 'downloadLink',
      label: 'Download Wire Information',
      linkLabel: 'WillyGoat Wire Information',
      value: wireInformationLink,
      showWhen: {
        field: 'paymentMethod',
        includes: 'Wire/ACH',
      },
    },
    {
      name: 'mailingAddress',
      type: 'readOnly',
      label: 'Mailing Address',
      value: mailingAddress,
      showWhen: {
        field: 'paymentMethod',
        includes: 'Check',
      },
      
    },

    
    {
      name: 'currentPO',
      type: 'radio',
      label: 'Do you have your PO ready?',
      options: [
        { value: 'yes', label: 'Yes' },
        { value: 'no', label: 'No' },
      ],
      required: true,
      checked: false,
      showWhen: {
        field: 'paymentMethod',
        includes: PAYMENT_METHOD_GOV_PO,
      },
    },
    // {
    //   name: 'text',
    //   type: 'textarea',
    //   label: 'Add a note to your quote (optional)',
    //   placeholder: 'Enter any special instructions or notes...',
    //   required: false
    // }
  ],
  approvePo: [
    // {
    //   name: 'poNumber',
    //   type: 'text',
    //   label: 'Purchase order number',
    //   placeholder: 'PO #',
    //   required: false
    // },
    {
      name: 'poFile',
      type: 'file',
      label: 'Upload your purchase order document if available',
      shortLabel: "Upload PO",
      accept: '.pdf,.png,.jpg,.jpeg',
      required: false,
      maxSizeMB: 10,
      showWhenAll: [
        { field: 'paymentMethod', includes: PAYMENT_METHOD_GOV_PO },
        { field: 'currentPO', equals: 'yes' },
      ],
    }
  ],
  decline: [
    {
      name: 'declineReasons',
      type: 'checkbox_list',
      label: "Why are you declining this quote? (select all that apply)",
      shortLabel: 'Decline reason',
      options: declineReasonOptionsValues,
      required: false,
    },
  
    // Price too high → follow-ups
    {
      name: 'declinePriceOutsideRange',
      type: 'text',
      label: 'Price was outside of my price range',
      shortLabel: 'Price outside my range',
      placeholder: 'Share any details about the price being outside your range (optional)',
      required: false,
      showWhen: { field: 'declineReasons', includes: 'price_too_high' },
    },
    {
      name: 'declinePriceHelpRange',
      type: 'checkbox',
      options: [
        { value: 'yes', label: 'Yes' },
      ],
      label: 'Would you like help seeing what might fit in your range?',
      shortLabel: 'Help with price range',
      required: false,
      showWhen: { field: 'declineReasons', includes: 'price_too_high' },
    },
  
    // Cheaper elsewhere → follow-up
    {
      name: 'declineCheaperElsewhereHelp',
      type: 'checkbox',
      options: [
        { value: 'yes', label: 'Yes' },
      ],
      label: 'Could we take a look to see about matching the price?',
      shortLabel: 'Match price',
      required: false,
      showWhen: { field: 'declineReasons', includes: 'cheaper_elsewhere' },
    },
  
    // Cheaper elsewhere → optional URL + upload
    {
      name: 'declineCheaperElsewhereQuoteFile',
      type: 'file',
      label: 'Upload the other quote (optional)',
      shortLabel: 'Upload other quote',
      accept: '.pdf,.png,.jpg,.jpeg',
      maxSizeMB: 10,
      required: false,
      showWhen: { field: 'declineReasons', includes: 'cheaper_elsewhere' },
    },
  
    // Better product → follow-up
    {
      name: 'declineBetterProductDetails',
      type: 'textarea',
      label: 'That’s great! Can you please share more so we can learn more?',
      shortLabel: 'Better product details',
      placeholder: 'Share any details about the other product (optional)',
      required: false,
      keepPosition: true,
      showWhen: { field: 'declineReasons', includes: 'better_product' },
    },
  
    // Better lead time → follow-up
    {
      name: 'declineBetterLeadTimeDetails',
      type: 'textarea',
      label: 'That’s odd, generally lead times are standard. Please share more so we can take a look!',
      shortLabel: 'Better lead time details',
      placeholder: 'Share any details about the lead time you found (optional)',
      required: false,
      keepPosition: true,
      showWhen: { field: 'declineReasons', includes: 'better_lead_time' },
    },
  
    // Project cancelled/delayed → follow-up + conditional date
    {
      name: 'declineReachOutLater',
      type: 'checkbox',
      options: [
        { value: 'yes', label: 'Yes' },
      ],
      label: 'That’s okay, would you like for us to reach back out at a later day?',
      shortLabel: 'Reach back out later',
      required: false,
      showWhen: { field: 'declineReasons', includes: 'project_cancelled_delayed' },
    },
    {
      name: 'declineReachOutDate',
      type: 'date',
      label: 'Please provide the date',
      required: true,
      showWhenAll: [
        { field: 'declineReasons', includes: 'project_cancelled_delayed' },
        { field: 'declineReachOutLater', includes: 'yes' },
      ],
    },
  
    // Something else missed the mark → freeform details
    {
      name: 'declineSomethingElseDetails',
      type: 'textarea',
      label: 'Please let us know and we will jump right on it!',
      shortLabel: 'Something else details',
      placeholder: 'Share what missed the mark (optional)',
      required: false,
      keepPosition: true,
      showWhen: { field: 'declineReasons', includes: 'something_else_missed_mark' },
    },
  ],


  requestUpdates: [
    {
      name: 'selectedReason',
      type: 'checkbox_list',
      label: 'What would you like to change? (select all that apply)',
      shortLabel: "Update reason",
      options: updateReasonOptionsValues,
      required: true
    },
    {
      name: 'updateItems',
      type: 'textarea',
      label: 'Add or Remove Items',
      shortLabel: "Add or remove items",
      placeholder: "Please describe the product changes you'd like to make....",
      required: true,
      showWhen: {
        field: 'selectedReason',
        includes: 'Add or Remove Items',
      },
    },
    {
      name: 'changeColors',
      type: 'textarea',
      label: 'Change Colors',
      shortLabel: "Change colors",
      placeholder: "Please describe the color changes you'd like to make",
      required: true,
      showWhen: {
        field: 'selectedReason',
        includes: 'Change Colors',
      },
    },
    {
      name: 'addOrRemoveInstallation',
      type: 'textarea',
      label: 'Add or Remove Installation',
      shortLabel: "Add or remove installation",
      placeholder: "Anything else we should know about your installation",
      required: false,
      showWhen: {
        field: 'selectedReason',
        includes: 'Add or Remove Installation',
      },
    },
    {
      name: 'updateShipping',
      type: 'textarea',
      label: 'Change Shipping/Contact Information',
      shortLabel: "Change shipping/contact info",
      placeholder: 'Please give us the full shipping and/or contact information update...',
      required: true,
      showWhen: {
        field: 'selectedReason',
        includes: 'Change Shipping/Contact Information',
      },
    },
    {
      name: 'somethingElse',
      type: 'textarea',
      label: 'Something Else',
      shortLabel: "Something else",
      placeholder: 'Please describe how we can help...',
      required: true,
      showWhen: {
        field: 'selectedReason',
        includes: 'Something Else',
      },
    },
    {
      name: 'taxCertificate',
      type: 'file',
      required: true,
      label: 'Upload Tax Exemption Certificate',
      shortLabel: "Upload tax exemption",
      accept: '.pdf,.png,.jpg,.jpeg',
      maxSizeMB: 10,
      showWhen: {
        field: 'selectedReason',
        includes: 'Remove Taxes',
      },
    },
    {
      name: 'anythingElse',
      type: 'text',
      label: "Anything else you'd like for us to know?",
      shortLabel: "Anything else",
      placeholder: 'Let us know!',
      required: false,
      showWhen: {
        field: 'selectedReason',
        notEmpty: true,
      },
    }
  ],
  requestExtension: [
    {
      name: 'text',
      type: 'textarea',
      label: 'Is there anything else you would like to add?',
      shortLabel: "Anything else",
      placeholder: 'Enter your request...',
      required: false
    }
  ],
  askQuestion: [
    {
      name: 'text',
      type: 'textarea',
      label: 'Have a question about your order?',
      shortLabel: "Question",
      placeholder: 'Enter your question...',
      required: true
    }
  ]
};

export const modalConfig = {
  approve: {
    title: 'Approve Quote',
    className: 'approve-quote-modal',
    description: 'Thanks for trusting WillyGoat with your order! Please check the following acknowledgements and select a payment option.',
    placeholder: 'Enter any special instructions or notes...',
    primaryButton: 'Confirm Approval',
    // secondaryButton: 'Request Updates',
    showSecondary: false,
    buttonClass: 'button--primary button--bordered',
    fields: modalFieldDefinitions.approve
  },
  decline: {
    title: 'Decline Quote',
    className: 'decline-quote-modal',
    description: 'We are sorry we aren’t able to help you (at least for now)! We would very much appreciate any feedback!',
    placeholder: 'Enter your reason...',
    primaryButton: 'Decline Quote',
    showSecondary: true,
    secondaryButton: 'Request Updates',
    buttonClass: 'button--danger button--bordered',
    // fields: [...declineFieldsWithFollowUps]
    fields: modalFieldDefinitions.decline
  },
  requestUpdates: {
    title: 'Request Updates',
    className: 'request-updates-modal',
    description: "Make any changes to your quote below. In most cases, this can be done on the same day.",
    placeholder: 'Enter your update request...',
    primaryButton: 'Request Updates',
    showSecondary: false,
    buttonClass: 'button--secondary button--bordered',
    fields: modalFieldDefinitions.requestUpdates
  },
  requestExtension: {
    title: 'Request Extension',
    className: 'request-extension-modal',
    description: "Request an extension to your quote.",
    placeholder: 'Other Notes...',
    primaryButton: 'Request Extension',
    showSecondary: false,
    buttonClass: 'button--secondary button--bordered',
    fields: modalFieldDefinitions.requestExtension
  },
  askQuestion: {
    title: 'Ask a Question',
    className: 'ask-question-modal',
    description: "Have a question about your order? We're here to help!",
    placeholder: 'Enter your question...',
    primaryButton: 'Ask a Question',
    showSecondary: false,
    buttonClass: 'button--secondary button--bordered',
    fields: modalFieldDefinitions.askQuestion
  },
  success: {
    showTextarea: false
  }
};